import Video from './Video';
import VimeoVideoPlayer from "./VimeoVideoPlayer";
import Player from '@vimeo/player';
export default class Testimonials {
    init(block) {
        this.blockButtons   = block.querySelectorAll('[data-testimonial]');
        this.blockVideos    = block.querySelectorAll('[data-video]');

        this.blockButtons && this.blockButtons.forEach((blockButton) => {
            blockButton.addEventListener('click', (event) => {
                this.changeTestimonial(blockButton, this.blockButtons, this.blockVideos);
            });
        });
    }

    changeTestimonial(clickedButton, allButtons, allVideos) {
        allButtons.forEach((button) => {
            button.classList.remove('selected');
            if(button.getAttribute("data-testimonial") === clickedButton.dataset.testimonial) {
                button.classList.add('selected');
            }
        });

        allVideos.forEach((video) => {
            video.classList.remove('selected');
            let player = new Player(video.querySelector('iframe'));
            player.pause();
            video.querySelector('.play-button').classList.remove('playing');
            if(video.getAttribute("data-title") === clickedButton.dataset.testimonial) {
                video.classList.add('selected');
            }
        });
    }
}